import { useMutation, useQueryClient } from 'react-query';
import request from '../../../helpers/request';
import infoHeaderImgQuery from '../queries/infoHeaderImgQuery';

const { createKey } = infoHeaderImgQuery;

const add = async (infoId, data) =>
  request.post(
    `/Information/${infoId}/image`,
    data,
    'Не удалось добавить шапку к информированию',
    'Error'
  );

const useAddHeaderImg = () => {
  const queryClient = useQueryClient();

  const addMutation = useMutation(({ infoId, data }) => add(infoId, data), {
    onSuccess: async (data, { infoId, reset }) => {
      if (data !== 'Error') {
        if (typeof reset === 'function') {
          reset();
        }

        queryClient.invalidateQueries(createKey(infoId));
      }
    },
  });

  return {
    add: addMutation.mutate,
    addAsync: addMutation.mutateAsync,
    loading: addMutation.isLoading,
  };
};

export default useAddHeaderImg;
